import React, { useEffect, useState } from "react";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";
import { formatDate } from "../../utils/formatDate";
import { Modal, Button, Table } from "react-bootstrap";

const ProductionStockModalView = ({ show, handleClose, dateWise, productId }) => {
  const [loading, setLoading] = useState(false);
  const [stockData, setStockData] = useState([]);

  const fetchProductionprogresspage = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.API}/supervisor/productionprogresspageupdate`,
        {
          date: dateWise,
          product_id: productId
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setStockData(response?.data?.warehose || []);
    } catch (err) {
      console.error("Error fetching production stock:", err);
      setStockData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && dateWise) {
      fetchProductionprogresspage();
    }
  }, [show, dateWise]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      backdrop="static" className="font_family"
    >
      {/* Header with Close Icon */}
      <Modal.Header closeButton>
        <Modal.Title>Production Stock</Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body className="bg-light">
        {loading ? (
          <Loader />
        ) : (
          <>
            {stockData.length > 0 ? (
              stockData.map((row, index) => (
                <div className="card mb-3 shadow-sm border-0" key={index}>
                  <div className="card-body">

                    {/* Top Header */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                      <h6 className="mb-0 text-primary fw-bold">
                        📅 {formatDate(row.created_at)}
                      </h6>


                      <h6 className="mb-0 text-dark fw-bold">
                        Production Date : {" "}
                        {row?.production_date
                          ? formatDate(row.production_date)
                          : "N/A"}
                      </h6>

                      <span
                        className={`badge rounded-pill px-3 py-2 ${row.status === "Pending"
                            ? " bg-danger bg-opacity-10 text-dark"
                            : row.status === "Approved"
                              ? "bg-success"
                              : "bg-secondary bg-opacity-10"
                          }`}
                      >
                        {row.status}
                      </span>
                    </div>

                    {/* Meta Info */}
                    <div className="row g-2 small">
                      <div className="col-md-3 col-12">
                        <span className=" fw-semibold">Product</span>
                        <div className="text-muted">{row?.product?.name}</div>
                      </div>

                      <div className="col-md-3 col-3">
                        <span className=" fw-semibold">Supervisor</span>
                        <div className="text-muted">{row?.supervisor?.name}</div>
                      </div>
                      <div className="col-md-3 col-3">
                        <span className=" fw-semibold">Operator</span>
                        <div className="text-muted">{row?.operator?.name}</div>
                      </div>
                      <div className="col-md-3 col-3">
                        <span className="text-muted fw-semibold">Machine</span>
                        <div className="">{row?.machine?.machine_code}</div>
                      </div>
                    </div>

                    <hr />

                    {/* Quantity Stats */}
                    <div className="row text-center g-3">
                      <div className="col-6 col-md-4">
                        <div className="p-3 rounded bg-success bg-opacity-10">
                          <div className="fs-5 fw-bold text-success">
                            {row.actual_quantity}
                          </div>
                          <div className="small text-muted">Produced</div>
                        </div>
                      </div>

                      <div className="col-6 col-md-4">
                        <div className="p-3 rounded bg-danger bg-opacity-10">
                          <div className="fs-5 fw-bold text-danger">
                            {row.quantity_rejected}
                          </div>
                          <div className="small text-muted">Rejected</div>
                        </div>
                      </div>
                      <div className="col-6 col-md-4">
                        <div className="p-3 rounded bg-dark bg-opacity-10">
                          <div className="fs-5 fw-bold text-dark">
                            {row.actual_quantity}
                          </div>
                          <div className="small text-muted">Actual Qty</div>
                        </div>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 small text-muted gap-2">
                      <span>📝 Notes : {row.notes || 'NA'}</span>
                    </div>

                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-muted py-5">
                No production stock data found
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProductionStockModalView;